<template>
    <div>
        <rkm-modal
            extra-large
            persistent
            ref="RkmModal"
            title="Chegada do paciente"
        >
            <rkm-form
                v-if="model"
                ref="RkmForm"
            >
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.opcoesEntrada"
                            :validations="validations.opcaoEntrada"
                            label="Opção de entrada"
                            show-default-option
                            text-field="nome"
                            v-model="model.opcaoEntradaId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.prioridades"
                            :validations="validations.prioridade"
                            label="Prioridade"
                            show-default-option
                            text-field="nome"
                            v-model="model.prioridadeId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row v-if="form.servicos.length > 0">
                    <rkm-col cols="12">
                        <rkm-form-checkbox-group
                            :options="form.servicos"
                            label="Serviços"
                            text-field="nome"
                            v-model="model.servicos"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="12">
                        <rkm-form-select
                            :options="form.centrosCustoEncaminhamento"
                            :validations="validations.centroCustoEncaminhamento"
                            label="Encaminhamento"
                            show-default-option
                            text-field="setorNome"
                            v-model="model.centroCustoEncaminhamentoId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>
            </rkm-form>

            <template v-slot:footer="{cancel}">
                <rkm-button
                    :disabled="!!loading"
                    @click="cancel"
                >
                    Cancelar
                </rkm-button>

                <rkm-button
                    :disabled="!!loading"
                    @click="save"
                    color="primary"
                >
                    Salvar
                </rkm-button>
            </template>
        </rkm-modal>

        <ModalImpressao
            @closed="closedModalImpressao"
            ref="ModalImpressao"
        />
    </div>
</template>

<script>
// Components.
import ModalImpressao from '@/components/ambulatorio/components/impressao/Modal'

// Mixins.
import {error, formats, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions, mapGetters} from 'vuex'

export default {
    components: {ModalImpressao},
    computed: {
        ...mapGetters({loading: 'getLoading'}),
        validations() {
            return {
                opcaoEntrada: {required: true},
                prioridade: {
                    required:
                        !!this.model.opcaoEntradaId &&
                        this.form.opcoesEntrada.find(opcaoEntrada => opcaoEntrada.id === this.model.opcaoEntradaId).prioridadeObrigatoria
                },
                centroCustoEncaminhamento: {required: true},
            }
        },
    },
    created() {
        this.repositories = {
            gerenciamentoDiario: this.getConectaSusRepository('ambulatorio.gerenciamentoDiario'),
        }
    },
    data: () => ({
        agendamentoId: null,
        form: null,
        model: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(agendamentoId) {
            this.reset()

            this.agendamentoId = agendamentoId

            this.create()

            this.$refs.RkmModal.show()
        },
        create() {
            this.setLoading()

            const request = {origem: 'chegada'}

            this.repositories.gerenciamentoDiario.create(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form = Object.assign(response.data.form)
                    this.model = Object.assign(response.data.model)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        store() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    this.setLoading()

                    const request = {
                        origem: 'chegada',
                        agendamentoId: this.agendamentoId,
                        opcaoEntradaId: this.model.opcaoEntradaId,
                        prioridadeId: this.model.prioridadeId,
                        servicos: this.model.servicos,
                        centroCustoEncaminhamentoId: this.model.centroCustoEncaminhamentoId,
                    }

                    this.repositories.gerenciamentoDiario.store(this.camelObjectKeysToSnakeRecursive(request))
                        .then(response => this.openModalImpressao(response.data.id))
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        save() {
            this.store()
        },
        openModalImpressao(atendimentoId) {
            this.$refs.ModalImpressao.open('recepcao', atendimentoId)
        },
        closedModalImpressao() {
            this.$refs.RkmModal.hide()
            this.$emit('saved')
        },
        reset() {
            this.agendamentoId = null
            this.form = null
            this.model = null
        },
    },
    mixins: [error, formats, repository, stringCase],
}
</script>